import clsx from 'clsx'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

import { PageWithHeader, PageWrapper } from '@/components/layout'
import { Flex } from '@/components/layout/Flex'
import { ROUTE, CONTACT_TITLE } from '@/const'
import { useSession } from '@/hooks/features/auth'

export const ContactPage = () => {
  const { t } = useTranslation()
  const { isAuthenticated } = useSession()
  const links = [
    {
      label: t('contact.links.forgotPassword'),
      href: ROUTE.contactForm('password'),
    },
    {
      label: t('contact.links.unlockAccount'),
      href: ROUTE.contactForm('locked-account'),
    },
    { label: t('contact.links.appFeatures'), href: ROUTE.contactForm('app') },
    { label: t('contact.links.otherIssues'), href: ROUTE.contactForm('other') },
  ] as const
  return (
    <PageWithHeader
      breadcrumb={[
        { label: t('pages.common.home'), href: ROUTE.top },
        { label: CONTACT_TITLE },
      ]}
      withSearch={false}
      withMenu={isAuthenticated}
      withLinks={isAuthenticated}
    >
      <PageWrapper withBreadcrumb={true} spacingX={'sm'}>
        <Flex
          center
          direction={'column'}
          className={clsx(
            'tw-mt-6 tw-px-4 tw-py-4',
            'tw-rounded tw-border tw-border-gray-300'
          )}
        >
          <span
            className={clsx(
              'tw-text-xl tw-font-semibold xs:tw-text-lg',
              'tw-whitespace-pre-wrap',
              'tw-max-w-[490px]'
            )}
          >
            {t('contact.orderInquiries')}
          </span>
          <Flex
            direction={'column'}
            gap={1}
            className={clsx('tw-text-sm xs:tw-text-xs', 'tw-mt-4')}
          >
            <span className={clsx('tw-inline-block')}>
              {t('contact.branchHint')}
            </span>
            <span className={clsx('tw-inline-block')}>
              {t('contact.branchListPrefix')}
              <a
                href={'https://www.kikuya-bisyodo.co.jp/about#offices'}
                target={'_blank'}
                rel={'noopener noreferrer'}
                className={clsx('tw-text-primary-400', 'tw-underline')}
              >
                {t('contact.branchListLink')}
              </a>
            </span>
          </Flex>
        </Flex>
        <h3
          className={clsx(
            'tw-mt-12',
            'tw-font-semibold',
            'tw-text-base xs:tw-text-sm'
          )}
        >
          {t('contact.otherInquiries')}
        </h3>
        <div
          className={clsx(
            'tw-grid tw-grid-cols-2 xs:tw-grid-cols-1',
            'tw-mt-4 tw-gap-6 xs:tw-gap-2'
          )}
        >
          {links.map((link) => (
            <Link href={link.href} key={link.href}>
              <Flex
                as={'span'}
                className={clsx(
                  'tw-rounded tw-bg-white',
                  'tw-border tw-border-primary-500',
                  'tw-py-6',
                  'tw-transition-colors hover:tw-bg-primary-50',
                  'tw-cursor-pointer'
                )}
                center
              >
                <span
                  className={clsx(
                    'tw-font-semibold',
                    'tw-text-primary-500',
                    'tw-text-base xs:tw-text-sm'
                  )}
                >
                  {link.label}
                </span>
              </Flex>
            </Link>
          ))}
        </div>
      </PageWrapper>
    </PageWithHeader>
  )
}
